import React from 'react';
import { LocationOn, BusinessCenter, Schedule } from '@mui/icons-material';

const JobListing = ({ job }) => {
    return (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-all">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-4">
                <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{job.title}</h3>
                    <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mb-4">
                        <div className="flex items-center space-x-1">
                            <LocationOn fontSize="small" />
                            <span>{job.location}</span>
                        </div>
                        <div className="flex items-center space-x-1">
                            <BusinessCenter fontSize="small" />
                            <span>{job.type}</span>
                        </div>
                        <div className="flex items-center space-x-1">
                            <Schedule fontSize="small" />
                            <span>{job.duration}</span>
                        </div>
                    </div>
                    <p className="text-gray-700 mb-4">{job.description}</p>
                    <div className="flex flex-wrap gap-2">
                        {job.tags.map((tag, index) => (
                            <span
                                key={index}
                                className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-medium"
                            >
                                {tag}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
            <div className="flex flex-wrap gap-3 pt-4 border-t border-gray-200">
                <a
                    href={`mailto:careers@netikash.com?subject=Candidature - ${job.title}`}
                    className="px-6 py-2 bg-gradient-to-r from-amber-500 to-yellow-600 text-white rounded-lg font-medium hover:from-amber-600 hover:to-yellow-700 transition-all"
                >
                    Postuler
                </a>
                <button className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-all">
                    Voir les détails
                </button>
            </div>
        </div>
    );
};

export default JobListing;